import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { pillarArticles } from '@/mocks/articles';

export default function PillarArticles() {
  const { t } = useTranslation();

  return (
    <section id="guides" className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
      <div className="text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">{t('pillar.title')}</h2>
        <p className="mx-auto mt-3 max-w-2xl text-sm md:text-base text-foreground-600">{t('pillar.subtitle')}</p>
      </div>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {pillarArticles.map((article) => (
          <Link
            key={article.slug}
            to={`/guides/${article.slug}`}
            className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 hover:border-primary-300 hover:bg-background-100 transition-colors cursor-pointer"
          >
            <div className="flex items-center gap-2">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-900">
                <i className="ri-article-line w-3.5 h-3.5 flex items-center justify-center" />
                {article.tag}
              </span>
              <span className="text-xs text-foreground-500 flex items-center gap-1">
                <i className="ri-time-line w-3.5 h-3.5 flex items-center justify-center" />
                {article.readTime}
              </span>
            </div>
            <h3 className="mt-4 font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug group-hover:text-primary-700 transition-colors">
              {article.title}
            </h3>
            <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{article.excerpt}</p>
            <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-700 whitespace-nowrap">
              {t('pillar.read')}
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center transition-transform group-hover:translate-x-0.5" />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}